import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    name: ""
}
const mutation = {
    //1.不带参数的方式
    changeName(state) {
        state.name = "";
    },
    //2.带参数的方式
    changeNameParam(state, payload) {
        state.name = payload.name;
    }
}
const actions = {
   
}
const modules = {
   
}
export default new Vuex.Store({
    state,
    mutation,
    actions,
    modules
})


// WEBPACK FOOTER //
// ./src/vuex/store.js